// eslint-disable-next-line no-restricted-imports
import type { GrowthBook } from '@growthbook/growthbook-react';
import Cookies from 'js-cookie';

import type { ExperimentsOverrideConfig, GrowthBookFlagKeys } from 'src/common/interfaces/feature-flags';
import type { AppFeatures } from 'src/common/interfaces/growthbook-generated-types';

import { EXPERIMENTS_CONFIG_COOKIE } from '../../constants';

export const getExperimentOverrides = (gb: GrowthBook<AppFeatures>): Map<GrowthBookFlagKeys, boolean> | null => {
  if (process.env.REACT_APP_ENVIRONMENT === 'production') {
    return null;
  }

  const storedExperimentsConfig = Cookies.get(EXPERIMENTS_CONFIG_COOKIE);
  const payload = gb.getPayload();
  const features = payload?.features;

  if (!storedExperimentsConfig || !payload || !features) {
    return null;
  }

  let experimentsConfig: ExperimentsOverrideConfig;
  try {
    experimentsConfig = JSON.parse(storedExperimentsConfig) as ExperimentsOverrideConfig;
  } catch (error) {
    console.error('Invalid experiments config override data', error, storedExperimentsConfig);
    return null;
  }

  const enabledKeys = new Set(experimentsConfig.enabled || []);

  const overrideEntries = Object.keys(features)
    .filter((key) => features[key]?.rules?.find((rule) => !!rule.variations?.length))
    .map((key) => {
      const shouldEnable = enabledKeys.has(key as GrowthBookFlagKeys);
      return [key, shouldEnable];
    }) as [GrowthBookFlagKeys, boolean][];

  const overrideMap = new Map(overrideEntries);
  if (overrideMap.size) {
    console.warn('Overriding experiments:', overrideMap);
    gb.setForcedFeatures(overrideMap);
  }

  return overrideMap;
};
